import HomeContent from "../components/Home/HomeContent";

const HomePage=()=>{
   return <HomeContent />
};

export default HomePage;